import "./LoanOptions.module.css";
import Header from "@/reusable_sections/Header";
import MortgageSolutionsSuite from "./sections/MortgageSolutionsSuite";
import CompareYourOptions from "./sections/CompareYourOptions";
import Footer from "@/reusable_sections/Footer";
export default function LoanOptionsPage() {
  return <div>
      <Header />
      <MortgageSolutionsSuite />
      <CompareYourOptions />
      <Footer />
    </div>;
}